import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=4bf40152&scoped=true&"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts&"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=4bf40152&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf40152",
  null
  
)

export default component.exports